var styles = {"accordionInlineWrapper":"VBG__DS__accordion-inline-module__1h_CD"};

export { styles as default };
